import { withInstall } from '@lit-element/utils'

import Empty from './src/empty.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtEmpty: SFCWithInstall<typeof Empty> = withInstall(Empty)
export default LtEmpty

export * from './src/empty'
export type { EmptyInstance } from './src/instance'
